import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../utils/auth';

function ProtectedRoute({ children, allowedRoles = [] }) {
  const token = localStorage.getItem('token');
  const user = token ? JSON.parse(atob(token.split('.')[1])) : null;

  if (!isTokenValid()) {
    return <Navigate to="/login" replace />;
  }

  // If no roles are required, allow access
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user has permission for this route
  if (!allowedRoles.includes(user.role)) {
    // If user is ONLY a customer (no dual role), redirect to customer dashboard
    if (user.role === 'customer') {
      return <Navigate to="/customer" replace />;
    }
    // Otherwise, redirect to home page
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;